import { NavLink, Outlet, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import "./Aboutpage.css";
 
const sidebarLinks = [
  { label: "Vision", path: "/about/vision" },
  { label: "Mission", path: "/about/mission" },
  { label: "Purpose", path: "/about/purpose" },
  { label: "Value Proposition", path: "/about/value-proposition" },
  { label: "Advisory Team", path: "/about/leadership" },
];

export default function AboutPage() {
  const location = useLocation();
  const isRoot =
    location.pathname === "/about" || location.pathname === "/about/";

  // Scroll to top when location changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // or "instant" for immediate scroll
    });
  }, [location.pathname]);

  return (
    <div className="about-layout">
      {/* ── Sidebar ── */}
      <aside className="about-sidebar">
        <p className="about-sidebar__heading">About</p>
        <nav className="about-sidebar__nav">
          {sidebarLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) =>
                isActive
                  ? "about-sidebar__link about-sidebar__link--active"
                  : "about-sidebar__link"
              }
            >
              <span className="about-sidebar__dot" />
              {link.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* ── Main content ── */}
      <main className="about-main">
        {isRoot ? <Navigate to="/about/vision" replace /> : <Outlet />}
      </main>
    </div>
  );
}
